import React from 'react';
import { Badge } from '@roger/ui-components';
import { getClinicRogerOnlyPillLabel } from '../../utils/clinicEmr';

export type ClinicEmrBadgeProps = {
  /** Clinic used to decide whether to show the Roger Only pill. */
  clinic?: {
    is_kinnser?: boolean;
    clinic_source?: string | null;
  } | null;
  className?: string;
};

/**
 * Compact EMR affiliation chip for clinic pickers.
 *
 * In dual-EMR agencies, shows "Roger Only" for non-Kinnser clinics and
 * renders nothing for Kinnser-participating clinics (or when clinic is missing).
 */
export function ClinicEmrBadge({
  clinic,
  className,
}: ClinicEmrBadgeProps): React.ReactElement | null {
  const label = getClinicRogerOnlyPillLabel(clinic);
  if (!label) return null;
  return (
    <Badge
      variant='outline'
      className={
        className ?? 'shrink-0 text-xs font-normal text-muted-foreground'
      }
    >
      {label}
    </Badge>
  );
}
